import React from 'react'
import { Link } from 'react-router-dom'

const Pricing = () => {
  return (
    <div className='text-gray-700 pt-20 pb-20 p-4 max-w-[900px] mx-auto'>
      <div className='text-center'>
        <h3 className='text-3xl pb-4 font-bold'>Choose Your Plan</h3>
        <p className='text-2xl pb-12 font-semibold'>Budget friendly pricing to suit your requirements</p>

      </div>
      <div className='flex flex-col gap-8 md:gap-4 md:flex-row'>

        <div className='flex-1 py-8 px-2 md:py-2 font-semibold'>
          <p className='text-xl py-4 font-semibold text-center bg-yellow-300'>Starter</p>
          <p className='text-3xl pb-8 text-center'>$299 <span className='text-gray-500 text-sm'>/year</span></p>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Website Design</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Website Creation</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Domain Name</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Hosting</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Custom Landing Page</p>
          </div>

          <div className='text-gray-500'>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>

              0 Secondary Pages</p>
          </div>


          <Link to='/form' className='flex justify-center bg-gradient-to-br from-[#084cabb5] to-[#084cab] hover:from-black hover:to-black text-white text-xl py-2 mb-8 mx-4'>Register</Link>
        </div>


        <div className='flex-1 bg-yellow-500 rounded-md py-8 px-2 md:py-2 font-semibold'>
          <p className='text-xl py-4 font-semibold text-center border-[1.5px] border-white'>Advanced</p>
          <p className='text-3xl pb-8 text-center'>$499 <span className='text-gray-500 text-sm'>/year</span></p>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Website Design</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Website Creation</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Domain Name</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Hosting</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Custom Landing Page</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              1-3 Secondary Pages</p>
          </div>

          <Link to='/form' className='flex justify-center bg-gradient-to-br from-[#084cabb5] to-[#084cab] hover:from-black hover:to-black text-white text-xl py-2 mb-8 mx-4'>Register</Link>
        </div>



        <div className='flex-1 py-8 px-2 md:py-2 font-semibold'>
          <p className='text-xl py-4 font-semibold text-center bg-yellow-300'>Expert</p>
          <p className='text-3xl pb-8 text-center'>$999 <span className='text-gray-500 text-sm'>/year</span></p>



          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Website Design</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Website Creation</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Domain Name</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Hosting</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              Custom Landing Page</p>
          </div>

          <div>
            <p className='inline-flex'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 my-auto mr-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
              </svg>

              5-7 Custom Secondary Pages</p>
          </div>
          <Link to='/form' className='flex justify-center bg-gradient-to-br from-[#084cabb5] to-[#084cab] hover:from-black hover:to-black text-white text-xl py-2 mb-8 mx-4'>Register</Link>
        </div>
      </div>
    </div>
  )
}

export default Pricing